namespace TR {
    interface Supplier {
        Id: number;
        Name: string;
    }
    enum ProductType {
        Hotel = 'Hotel',
        Flight = 'Flight',
        Transfer = 'Transfer'
    }
    class Debug {
        suppliers;
        accomSuppliers;
        flightSuppliers;
        transferSuppliers;
        selectedAccomSupliers;
        selectedFlightSuppliers;
        selectedTransferSupliers;
        debugSettings;
        constructor(
            private agentModeService,
            private $scope : ng.IScope,
            private $q: ng.IQService,
            private $location : ng.ILocationService,
            private resourceService : Core.ResourceService
        ){
            agentModeService.getAgentInformation().then(() => {
                this.debugSettings = {
                    ShowNets: false,
                    DebugFlag: false,
                    RateMazeDebugFlag: false,
                    EnableSearchTracing: false,
                    AccomDebugFlag: false
                };

                $q.all([
                    agentModeService.getDebugSettings(),
                    agentModeService.getSuppliers()
                ]).then(([debugSettings, suppliers]) => {
                        this.debugSettings = _.extend(this.debugSettings, debugSettings);
                        this.suppliers = suppliers;
                        this.selectedAccomSupliers = this.mapSelectedSuppliers(ProductType.Hotel);
                        this.accomSuppliers = this.getUnSelectedSupliers(ProductType.Hotel);

                        this.selectedFlightSuppliers = this.mapSelectedSuppliers(ProductType.Flight);
                        this.flightSuppliers = this.getUnSelectedSupliers(ProductType.Flight);

                        this.selectedTransferSupliers = this.mapSelectedSuppliers(ProductType.Transfer);
                        this.transferSuppliers = this.getUnSelectedSupliers(ProductType.Transfer);
                }, () => {
                        $scope.$broadcast('flash:error', resourceService.get('FAILEDGETTINGDEBUGSETTINGS'));
                    });
             }, () => {
                $location.path('agents/signin').search({ Dest: TRPCONFIG.Domain.AgentLogonUrlDest });
            });
        }

        updateSettings() {
            this.debugSettings.SearchSupplierId = _.map(this.selectedAccomSupliers, (s: Supplier) => s.Id);
            this.debugSettings.SearchFlightSupplierIds = _.map(this.selectedFlightSuppliers, (s: Supplier) => s.Id);
            this.debugSettings.SearchTransferSupplierIds = _.map(this.selectedTransferSupliers, (s: Supplier) => s.Id);
            this.agentModeService.updateDebugSettings(this.debugSettings).then(() => {
                this.$scope.$broadcast('flash:success', this.resourceService.get('DEBUGSETTINGUPDATESUCCESS'));
            }, () => {
                this.$scope.$broadcast('flash:error', this.resourceService.get('DEBUGSETTINGUPDATEFAILURE'));
            });
        };

        supplierSelected(selected, productType) {
            let selectedSuppliers;
            let unSelectedSuppliers;
            if(productType === ProductType.Hotel){
                selectedSuppliers = this.selectedAccomSupliers;
            }
            else if (productType === ProductType.Flight){
                selectedSuppliers = this.selectedFlightSuppliers;
            }
            else if (productType === ProductType.Transfer){
                selectedSuppliers = this.selectedTransferSupliers;
            }
            if (selected && !_.find(selectedSuppliers, (s: Supplier) => s.Id === selected)) {
                selectedSuppliers.push(selected);
                 if(productType === ProductType.Hotel){
                    this.accomSuppliers = this.getUnSelectedSupliers(productType);
                }
                else if (productType === ProductType.Flight){
                    this.flightSuppliers = this.getUnSelectedSupliers(productType);
                }
                else if (productType === ProductType.Transfer){
                    this.transferSuppliers = this.getUnSelectedSupliers(productType);
                }
            }
        };

        getUnSelectedSupliers(productType) {
            let selectedSuppliers;
            let suppliers;
             if(productType === ProductType.Hotel){
                selectedSuppliers = this.selectedAccomSupliers;
                suppliers = this.suppliers.Hotel;
            }
            else if (productType === ProductType.Flight){
                selectedSuppliers = this.selectedFlightSuppliers;
                suppliers = this.suppliers.Flight;
            }
            else if (productType === ProductType.Transfer){
                selectedSuppliers = this.selectedTransferSupliers;
                suppliers = this.suppliers.Transfer;
            }
            return _.filter(suppliers, (s: Supplier) => !_.find(selectedSuppliers, (ss: Supplier) => ss.Id === s.Id));
        }

        mapSelectedSuppliers(productType) {
            let ids;
            let suppliers;
            if(productType === ProductType.Hotel){
                ids = this.debugSettings.SearchSupplierId;
                suppliers = this.suppliers.Hotel;
            }
            else if (productType === ProductType.Flight){
                ids = this.debugSettings.SearchFlightSupplierIds;
                suppliers = this.suppliers.Flight;
            }
            else if (productType === ProductType.Transfer){
                ids = this.debugSettings.SearchTransferSupplierIds;
                suppliers = this.suppliers.Transfer;
            }
            return _.map(ids, id =>
                _.find(suppliers, (s: Supplier) => s.Id === id)
            );
        }

        removeSupplier(id, productType) {
            if(productType === ProductType.Hotel){
                _.remove(this.selectedAccomSupliers, (s: Supplier) => s.Id === id);
                this.accomSuppliers = this.getUnSelectedSupliers(productType);
            }
            else if (productType === ProductType.Flight){
                _.remove(this.selectedFlightSuppliers, (s: Supplier) => s.Id === id);
                this.flightSuppliers = this.getUnSelectedSupliers(productType);
            }
            else if (productType === ProductType.Transfer){
                _.remove(this.selectedTransferSupliers, (s: Supplier) => s.Id === id);
                this.transferSuppliers = this.getUnSelectedSupliers(productType);
            }
        }
    }

    angular.module('TR').controller('Debug', Debug);
}
